/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {getUserByToken, login} from '../core/_requests'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import {decryptId, encryptId} from '_metronic/helpers/Encrypt'

const initialValues = {
  username: localStorage.getItem('username') || '',
  password: localStorage.getItem('password')
    ? decryptId(localStorage.getItem('password'))
    : '',
  rememberMe: false,
}

export function Login() {
  const {t} = useTranslation()
  const loginSchema = Yup.object().shape({
    username: Yup.string()
      .min(3, t('VALIDATION.MIN_CHARACTER_', {quantity: 3}))
      .max(50, t('VALIDATION.MAX_CHARACTER_', {quantity: 50}))
      .required(t('VALIDATION.REQUIRED_', {name: t('GLOBAL.USERNAME')})),
    password: Yup.string()
      .min(3, t('VALIDATION.MIN_CHARACTER_', {quantity: 3}))
      .max(50, t('VALIDATION.MAX_CHARACTER_', {quantity: 50}))
      .required(t('VALIDATION.REQUIRED_', {name: t('GLOBAL.PASSWORD')})),
  })
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await login(values.username, values.password)
        saveAuth(auth)
        const {data: user} = await getUserByToken(auth.api_token)
        setCurrentUser(user)
        if (values.rememberMe) {
          localStorage.setItem('username', values.username)
          localStorage.setItem('password', encryptId(values.password))
        }
      } catch (error: any) {
        if (error.response.data) {
          if (error.response.status === 404) {
            setStatus(t('MESSAGES.NOT_FOUND_ERROR'))
          } else {
            setStatus(error.response.data.message)
          }
        } else if (error.request) {
          console.log('request', error.request)
        } else {
          console.log('Error', error.message)
        }
        saveAuth(undefined)
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        <div></div>
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-3'>
        <label className='required'>{t('GLOBAL.USERNAME')}:</label>
        <input
          placeholder={t('GLOBAL.USERNAME')}
          {...formik.getFieldProps('username')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.username && formik.errors.username},
            {
              'is-valid': formik.touched.username && !formik.errors.username,
            }
          )}
          type='text'
          name='username'
          autoComplete='off'
        />
        {formik.touched.username && formik.errors.username && (
          <div className='text-danger'>{formik.errors.username}</div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-3'>
        <label className='required'>{t('GLOBAL.PASSWORD')}:</label>
        <input
          type='password'
          placeholder={t('GLOBAL.PASSWORD')}
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='text-danger'>{formik.errors.password}</div>
        )}
      </div>
      {/* end::Form group */}
      <div className='d-flex justify-content-between'>
        <label>
          <input
            type='checkbox'
            className='form-check-input mx-2'
            name='rememberMe'
            checked={formik.values.rememberMe}
            onChange={formik.handleChange}
          />
          {t('GLOBAL.REMEMBER_ME')}
        </label>
        <Link to='/forgot-password'>{t('GLOBAL.FORGOT_PASSWORD')}</Link>
      </div>
      {/* begin::Action */}
      <div className='d-grid py-4'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>{t('GLOBAL.LOGIN')}</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {t('GLOBAL.PLEASE_WAIT')}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </form>
  )
}
